import React from "react";
import "./style.css";

export const XpressPlugLanding = () => {
  return (
    <div className="xpl-land-phone-frame">
      <div className="xpl-land-phone-screen">
        <div className="xpl-land-status-bar" />

        <div className="xpl-land-scrollable">
          <div className="xpl-land-header">
            <div className="xpl-land-header-text">
              <span className="xpl-land-welcome">Welcome back,</span>
              <span className="xpl-land-name">Sebastian Melo</span>
            </div>
            <div className="xpl-land-avatar">
              <span>SM</span>
            </div>
          </div>

          <div className="xpl-land-divider" />

          <div className="xpl-land-balance-card">
            <div className="xpl-land-balance-label">Total Balance</div>
            <div className="xpl-land-balance-amount">$12,450.00</div>
            <div className="xpl-land-balance-row">
              <div className="xpl-land-balance-col">
                <div className="xpl-land-balance-sublabel">Income</div>
                <div className="xpl-land-income">+$3,200.00</div>
              </div>
              <div className="xpl-land-balance-separator" />
              <div className="xpl-land-balance-col">
                <div className="xpl-land-balance-sublabel">Expenses</div>
                <div className="xpl-land-expense">-$1,840.00</div>
              </div>
            </div>
          </div>

          <div className="xpl-land-section-title">Accounts</div>

          <div className="xpl-land-account-card">
            <div className="xpl-land-account-icon xpl-land-savings-icon">
              <span>S</span>
            </div>
            <div className="xpl-land-account-info">
              <div className="xpl-land-account-name">Savings</div>
              <div className="xpl-land-account-number">**** 1234</div>
            </div>
            <div className="xpl-land-account-balance">$8,250.00</div>
          </div>

          <div className="xpl-land-account-card">
            <div className="xpl-land-account-icon xpl-land-checking-icon">
              <span>C</span>
            </div>
            <div className="xpl-land-account-info">
              <div className="xpl-land-account-name">Checking</div>
              <div className="xpl-land-account-number">**** 5678</div>
            </div>
            <div className="xpl-land-account-balance">$4,200.00</div>
          </div>

          <div className="xpl-land-section-title">Recent Transactions</div>

          <div className="xpl-land-transaction-card">
            <div className="xpl-land-transaction-info">
              <div className="xpl-land-transaction-name">Grocery Store</div>
              <div className="xpl-land-transaction-date">Feb 13, 2026</div>
            </div>
            <div className="xpl-land-transaction-amount xpl-land-expense-text">-$85.40</div>
          </div>

          <div className="xpl-land-transaction-card">
            <div className="xpl-land-transaction-info">
              <div className="xpl-land-transaction-name">Salary Deposit</div>
              <div className="xpl-land-transaction-date">Feb 10, 2026</div>
            </div>
            <div className="xpl-land-transaction-amount xpl-land-income-text">+$3,200.00</div>
          </div>
        </div>
      </div>
    </div>
  );
};
